import User from '../../services/user'
import * as types from '../mutationTypes'

let state = {
  email: null,
  id: null,
  role: null,
  error: null,
  userToUpdate: null,
  users: [],
  usersNoRoles: [],
  crewLeads: [],
  archivedUsers: [],
  headers: [
    { text: 'ID', value: 'user.id' },
    { text: 'Username', value: 'user.email' },
    { text: 'First Name', value: 'user.firstName' },
    { text: 'Last Name', value: 'user.lastName' },
    { text: 'Phone', value: 'user.phoneNumber' },
    { text: 'Role', value: 'roles.name' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  currentUser: {}
}

const getters = {
  email (state) {
    return state.email
  },

  crewLeads (state) {
    var crewLead = state.users.filter(u => u.roles.id === 2)
    return crewLead.map(user => {
      return { text: user.user.firstName, value: user.user.id }
    })
  },
  id (state) {
    return state.id
  },
  role (state) {
    return state.role
  },

  selectList (state) {
    return state.users.map(u => {
      return { text: u.user.email, value: u.user.id }
    })
  },
  selectError (state) {
    return state.error
  },
  isDisabledList (state) {
    return state.users.map(u => {
      return { text: u.disabled, value: u.userID }
    })
  },
  users (state) {
    return state.users
  },
  archivedUsers (state) {
    return state.archivedUsers
  },
  headers () {
    return state.headers
  },
  currentUser (state) {
    return state.currentUser
  },
  usersNoRoles (state) {
    return state.usersNoRoles
  }
}

const actions = {
  async loadAllUsers ({ commit, dispatch }) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await User.getAllWithRoles()
      if (res) {
        commit(types.REQUEST_USER_LIST_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_USER_LIST_ERROR, 'Error loading user list' + err.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadUsersNRoles ({ commit }) {
    try {
      let res = await User.getAll()
      if (res) {
        commit(types.REQUEST_USER_LIST_NROLES_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_USER_LIST_NROLES_ERROR, 'Error loading user list' + err.message)
    }
  },
  async loadUser ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await User.get(id)
      if (res) {
        commit(types.UPDATE_USER, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_USER_ERROR, err.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },

  async loadArchivedUsers ({ commit, dispatch }) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await User.getAllArchived()
      if (res) {
        commit(types.REQUEST_ARCHIVE_USER_LIST_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_USER_LIST_ERROR, 'Error loading archived user list')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },

  async updateUser ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await User.update(data.id, data)
      if (res) {
        commit(types.UPDATE_USER, data)
        dispatch('loadAllUsers')
      }
    } catch (err) {
      commit(types.UPDATE_USER_ERROR, 'Error updating user ' + err.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },

  async deleteUser ({ commit, dispatch }, user) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await User.delete(user.id)
      if (res) {
        commit(types.DELETE_USER, res.data)
        dispatch('loadArchivedUsers')
      }
    } catch (err) {
      commit(types.REQUEST_USER_ERROR, `Error deleting user ${err}`)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },

  async archiveUser ({ commit, dispatch }, user) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await User.archive(user.id)
      if (res) {
        commit(types.ARCHIVE_USER_SUCCESS, res.data)
        dispatch('loadAllUsers')
      }
    } catch (err) {
      commit(types.ARCHIVE_USER_ERROR, 'Error archiving user')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },

  async restoreUser ({ commit, dispatch }, user) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await User.restore(user.id)
      if (res) {
        dispatch('loadArchivedUsers')
      }
    } catch (err) {
      commit(types.REQUEST_USER_ERROR, 'Error archiving user')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },

  async createUser ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await User.create(data)
      if (res) {
        commit(types.CREATE_USER, data)
        dispatch('loadAllUsers')
      }
    } catch (err) {
      commit(types.CREATE_USER_ERROR, 'Error creating user')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async setCurrentUser ({ commit }, data) {
    let currentUser = await User.get(data.id)
    currentUser.data.roles = data.roles
    commit(types.SET_CURRENT_USER, currentUser.data)
  },

  clear ({ commit }) {
    commit(types.CLEAR_USER)
  }
}

const mutations = {
  [types.SET_CURRENT_USER] (state, data) {
    state.currentUser = data
    state.email = data.email
    state.id = data.id
    state.role = data.roles[0]
  },
  [types.REQUEST_USER_ERROR] (state, message) {
    state.error = message
  },
  [types.UPDATE_USER] (state, data) {
    state.userToUpdate = data
    state.error = null
  },
  [types.CREATE_USER] (state, data) {
    state.error = null
  },
  [types.CREATE_USER_ERROR] (state, message) {
    state.email = null
    state.password = null
    state.role = null
    state.error = message
  },

  [types.CLEAR_USER] (state) {
    state.email = null
    state.id = null
    state.role = null
    state.error = null
  },

  [types.DELETE_USER] (state, index) {
    state.user = null
    state.error = null
  },

  [types.ARCHIVE_USER_SUCCESS] (state) {
    state.error = null
  },

  [types.ARCHIVE_USER_ERROR] (state, message) {
    state.error = message
  },

  [types.REQUEST_USER_LIST_SUCCESS] (state, users) {
    state.users = users
    state.error = null
  },
  [types.REQUEST_USER_LIST_NROLES_SUCCESS] (state, users) {
    state.usersNoRoles = users
    state.error = null
  },

  [types.REQUEST_ARCHIVE_USER_LIST_SUCCESS] (state, archivedUsers) {
    state.archivedUsers = archivedUsers
    state.error = null
  },

  [types.REQUEST_USER_LIST_ERROR] (state, message) {
    state.users = []
    state.error = message
  },

  [types.REQUEST_USER_LIST_NROLES_ERROR] (state, message) {
    state.usersNoRoles = []
    state.error = message
  },

  [types.UPDATE_USER_ERROR] (state, message) {
    state.userToUpdate = null
    state.error = message
  },

  [types.REQUEST_CREW_LEAD_LIST_SUCCESS] (state, data) {
    state.crewLeads = data
    state.error = null
  },
  [types.REQUEST_CREW_LEAD_LIST_ERROR] (state, message) {
    state.crewLeads = null
    state.error = message
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
